import { Grid2, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ReactElement, cloneElement } from 'react';

export interface SettingsFieldProps extends React.PropsWithChildren<{}> {
  label?: string;
  description?: string;
  disabled?: boolean;
}

export function SettingsField({
  label,
  description,
  disabled = false,
  ...rest
}: SettingsFieldProps) {
  const children = cloneElement(rest.children as ReactElement, {
    disabled: disabled,
  });

  return (
    <>
      <Grid2 container spacing={2} sx={{ mb: 3 }} alignItems={description ? 'top' : 'center'}>
        <Grid2 size={{ xs: 12, sm: 4, md: 12, lg: 4 }}>
          {label && (
            <Typography variant="h3" sx={{ pt: description ? 2 : 0 }}>
              {label}
            </Typography>
          )}
          {description && (
            <Box sx={{ lineHeight: 1, pt: 1 }}>
              <Typography variant="caption" color="textSecondary">
                {description}
              </Typography>
            </Box>
          )}
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 8, md: 12, lg: 8 }}>{children}</Grid2>
      </Grid2>
    </>
  );
}
